export default __webpack_public_path__ + "a9c4446.png";